import { ReopenData } from './Queries'

/**
 * Returns the most recent reopen detail from the array based on reopenDate.
 * Falls back to the first element if no dates are available.
 */
export const getLatestReopenDetail = (
  reopenDetails: ReopenData[] | undefined | null,
): ReopenData | undefined => {
  if (!reopenDetails || reopenDetails.length === 0) return undefined
  if (reopenDetails.length === 1) return reopenDetails[0]

  return reopenDetails.reduce((latest, current) => {
    if (!current?.reopenDate) return latest
    if (!latest?.reopenDate) return current
    return new Date(current.reopenDate) > new Date(latest.reopenDate)
      ? current
      : latest
  })
}
